export enum IV_DOCUMENT_ANIMATIONS {
  frontside = 'frontside',
  backside = 'backside',
  passport = 'passport',
  selfie = 'selfie',
  ocr = 'ocr',
}
